import { keyframes } from "@emotion/core"
import { fileCheck } from "helpers/files"
import { appear } from "styledElements/keyframes"

const images = fileCheck(require.context("../images", true))

const content = {
	images: [
		{
			src: "forest/bg_page4.jpg",
		},
		{
			src: "forest/birds_page4.png",
			class: "birds-p4",
			imgdiv: "imageCover",
		},
		{
			src: "forest/thunder_storm.gif",
			class: "thunder-p4",
			styles: {
				top: "-8%",
				left: "70%",
				opacity: 0,
				animation: `${keyframes({
					"0%": {
						opacity: 0,
					},
					"58%": {
						opacity: 0,
					},
					"60%": {
						opacity: 1,
					},
					"90%": {
						opacity: 1,
					},
				})} 8s linear infinite `,
			},
			imgdiv: "imageCover",
		},
		{
			src: "_.png",
			styles: {
				height: "200%",
				background: `url(${images("./forest/rain.png")}) 0px center / contain repeat`,
				backgroundPosition: "0% 0%",
				animation: `${keyframes({
					to: {
						backgroundPosition: "0% 100%",
					},
				})} 2s normal linear infinite`,
			},
		},
	],
	texts: [
		{
			textDivClass: "story_gauthali-text text-center",
			styles: {
				top: "32%",
				left: "58%",
				padding: "15px",
				background: "rgba(255, 255, 255, 0.8);",
				borderRadius: "15px",
				animation: `${appear} 1s 3s ease-out normal both`,
			},
			textIndivData: [
				{
					textData: "रात चिसो थरर",
					textClass: "m-0 p4-text_a",
					// timestamps: [{ start: 1 }, { start: 2 }],
				},
				{
					textData: "पानी पर्‍यो झरर",
					textClass: "m-0 p4-text_a",
					// timestamps: [{ start: 1 }, { start: 2 }],
				},
			],
		},
	],
	sounds: [
		{
			url: "p4.ogg",
			delay: 4000,
		},
		{
			url: "rainStrom.ogg",
			delay: 0,
			volume: 0.3,
			loop: true,
			isBg: true,
		},
	],
}

export default content
